import { Box, Stack } from '@mantine/core';
import { TextSkeleton } from '@repo/foundations';
import { memo } from 'react';
import { AiAgentsHistoryBody } from './AiAgentsHistoryBody';

export const AiAgentsHistorySkeleton = memo(() => (
	<AiAgentsHistoryBody>
		<Box>
			<Stack spacing="xs">
				<TextSkeleton size="sm" width={110} />
				<TextSkeleton size="sm" />
				<TextSkeleton size="sm" />
				<TextSkeleton size="sm" />
			</Stack>
		</Box>
	</AiAgentsHistoryBody>
));
